var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data !== null
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("Pagination", {
                    attrs: { numberOfDots: 5, numberOfVisitedDots: 5 }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "header-wrapper" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.screening.createremittanceheader
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _c("h5", { staticClass: "text-primary-fh left-header" }, [
                      _vm._v("Såhär har du svarat på frågorna:")
                    ]),
                    _vm._v(" "),
                    _vm.screening.length === 0
                      ? _c("div", [_vm._m(1)])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.screening.length > 0
                      ? _c(
                          "div",
                          _vm._l(_vm.screening, function(a, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "parent" },
                              [
                                _c("p", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(a.question) +
                                      "\n                "
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                ➢ " +
                                      _vm._s(a.answer) +
                                      "\n                "
                                  ),
                                  a.eggs
                                    ? _c("span", [
                                        _vm._v(_vm._s(a.eggs.answer))
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _vm._l(a.drugs, function(d, i) {
                                  return _c("div", { key: i }, [
                                    d.dose !== 0 &&
                                    d.unit !== 0 &&
                                    d.amountperday !== 0
                                      ? _c(
                                          "table",
                                          {
                                            staticClass: "table table-striped"
                                          },
                                          [
                                            _vm._m(2, true),
                                            _vm._v(" "),
                                            _c("tr", [
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.toTitleCase(d.name)
                                                  )
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(d.dose))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(_vm._s(d.unit))
                                              ]),
                                              _vm._v(" "),
                                              _c("td", [
                                                _vm._v(
                                                  _vm._s(
                                                    d.amountperday ||
                                                      d.injectionsperweek
                                                  )
                                                )
                                              ])
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                })
                              ],
                              2
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("p", {
                    domProps: {
                      innerHTML: _vm._s(_vm.data.screening.createremittancetext)
                    }
                  }),
                  _vm._v(" "),
                  _c("h5", {
                    staticClass: "text-primary-fh left-header",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.data.screening.createremittancecityheader
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.chosenCityLabId,
                        expression: "chosenCityLabId"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { disabled: _vm.paperReferral },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.chosenCityLabId = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: 0 } }, [
                      _vm._v("-- Ange stad --")
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.data.misc.remittancelist, function(labId, city) {
                      return _c(
                        "option",
                        { key: city, domProps: { value: labId } },
                        [
                          _vm._v(
                            "\n            " + _vm._s(city) + "\n          "
                          )
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("p", { staticClass: "text-primary-fh text-center" }, [
                  _vm._v("eller..")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.paperReferral,
                        expression: "paperReferral"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      disabled: _vm.chosenCityLabId !== 0,
                      id: "paperReferral"
                    },
                    domProps: {
                      checked: Array.isArray(_vm.paperReferral)
                        ? _vm._i(_vm.paperReferral, null) > -1
                        : _vm.paperReferral
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.paperReferral,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.paperReferral = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.paperReferral = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.paperReferral = $$c
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", {
                    staticClass: "form-check-label",
                    attrs: { for: "paperReferral" },
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.data.screening.createremittancepaperreftext
                      )
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "alert alert-warning alert-error",
                  domProps: { innerHTML: _vm._s(_vm.errmsg) }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg btn-block",
                    attrs: {
                      disabled: _vm.chosenCityLabId === 0 && !_vm.paperReferral
                    },
                    on: { click: _vm.createRemittance }
                  },
                  [_vm._v("\n          Klar\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-dark btn-lg btn-block",
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v("\n          ← Tillbaka\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text-muted" }, [
      _c("i", [_vm._v("Ej svarat ännu")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("th", [_vm._v("Läkemedel")]),
      _vm._v(" "),
      _c("th", [_vm._v("Dos")]),
      _vm._v(" "),
      _c("th", [_vm._v("Enhet")]),
      _vm._v(" "),
      _c("th", [_vm._v("Frekvens")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-451c30ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-451c30ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateRemittance.vue
// module id = null
// module chunks = 